import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { ConfigurationService } from '../../service/configuration.service';
import { Router } from '@angular/router';

@Component({
  selector: 'button-anonymize',
  templateUrl: './button-anonymize.component.html',
  styleUrls: ['./button-anonymize.component.css']
})
export class ButtonAnonymizeComponent implements OnInit {
  @Output() viewSensitiveUserDataChange = new EventEmitter<boolean>();

  public roleType: string;
  public allowEditingSensitiveData: boolean = false;

  constructor(
    private configurationService: ConfigurationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.roleType = AuthService.getUserRoleFromClaims();

    const isRegisterRoute = this.router.url.includes('/pages/register');

    this.configurationService.getByKeyName('AllowEditingSensitiveData').subscribe(config => {
      if(config != null){
        
        if(isRegisterRoute) this.allowEditingSensitiveData = config.value.toLowerCase() === 'true';
      }
    });
  }

  public anonymizeCheckedChange(event: boolean) {
    this.viewSensitiveUserDataChange.emit(event);
  }

}
